import type { Application } from '@/types/Activity'

export const hasResidentialData = (application: Application): boolean =>
  (application.context?.addresses?.length ?? 0) > 0
